import React from 'react';
import { Container, Row, Col, Card, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { investorResources } from '../data/categories';

const InvestorPage = () => {
  return (
    <Container className="py-5">
      <h1 className="mb-4">{investorResources.title}</h1>
      <p className="lead mb-5">{investorResources.description}</p>

      <Row>
        {investorResources.sections.map(section => (
          <Col key={section.id} md={6} className="mb-4">
            <Card className="h-100 shadow-sm hover-card">
              <Card.Body>
                <Card.Title>{section.title}</Card.Title>
                <Card.Text>{section.content}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <div className="mt-5">
        <h2 className="mb-4">Why Invest in Jamaica?</h2>
        <Card>
          <Card.Body>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <strong>Strategic Location</strong> - Jamaica is strategically located in the Caribbean, providing easy access to North and South American markets.
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>Stable Economy</strong> - Jamaica has a stable economy with a focus on growth and development.
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>Tourism Industry</strong> - Jamaica's thriving tourism industry offers numerous investment opportunities.
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>Government Incentives</strong> - The Jamaican government offers various incentives for foreign investors.
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>Natural Resources</strong> - Jamaica is rich in natural resources, including bauxite, limestone, and agricultural land.
              </ListGroup.Item>
            </ListGroup>
          </Card.Body>
        </Card>
      </div>

      <div className="mt-5">
        <h2 className="mb-4">Investment Sectors</h2>
        <Row>
          <Col md={4} className="mb-4">
            <Card className="h-100 shadow-sm hover-card">
              <Card.Body>
                <Card.Title>Tourism & Hospitality</Card.Title>
                <Card.Text>
                  Invest in hotels, resorts, attractions, and other tourism-related businesses in one of the Caribbean's most popular destinations.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="h-100 shadow-sm hover-card">
              <Card.Body>
                <Card.Title>Real Estate Development</Card.Title>
                <Card.Text>
                  Opportunities in residential, commercial, and mixed-use property development across Jamaica's growing urban centers.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="h-100 shadow-sm hover-card">
              <Card.Body>
                <Card.Title>Agriculture & Agro-processing</Card.Title>
                <Card.Text>
                  Jamaica's fertile land and tropical climate provide excellent conditions for agricultural investments and value-added processing.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      <div className="mt-5">
        <h2 className="mb-4">Contact Information for Investors</h2>
        <Card>
          <Card.Body>
            <p>For more information about investment opportunities in Jamaica, please contact:</p>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <strong>Jamaica Promotions Corporation (JAMPRO)</strong><br />
                18 Trafalgar Road, Kingston 10, Jamaica<br />
                Phone: +1 (876) 978-7755<br />
                Email: info@jamprocorp.com<br />
                Website: <a href="https://www.jamaicatradeandinvest.org/" target="_blank" rel="noopener noreferrer">www.jamaicatradeandinvest.org</a>
              </ListGroup.Item>
            </ListGroup>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default InvestorPage;
